import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import AppLoadingPage from "@/components/AppLoadingPage/AppLoadingPage";
import { fetchUserAppSettingsAction } from "@/features/settings/slices/userAppSettingsSlice";

interface AppAuthenticatedProps {
  children: React.ReactNode;
}

export default function AppAuthenticated({ children }: AppAuthenticatedProps) {
  const dispatch = useDispatch();

  const token = useSelector((state: RootState) => state.auth.token);
  const { userAppSettings, loading, error } = useSelector(
    (state: RootState) => state.userAppSettings,
  );

  useEffect(() => {
    if (token && !userAppSettings) {
      dispatch(fetchUserAppSettingsAction());
    }
  }, [token, userAppSettings, dispatch]);

  if (!token) {
    return null;
  }

  if (loading) {
    return <AppLoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center m-8">
        <h2 className="text-lg font-semibold text-red-600">
          Error loading user settings:
        </h2>
        <p>{error}</p>
      </div>
    );
  }

  return <>{children}</>;
}
